import { gql } from '@apollo/client';
import { DEVICE_FRAGMENT } from '@/entities/device/@x/study';
import DIAGNOSIS_FRAGMENT from '../fragments/diagnosisFragment';
import PATIENT_FRAGMENT from '../fragments/patientFragment';

const FLAGGED_STUDIES_QUERY = gql`
  query flaggedStudies($filter: FlaggedStudiesFilter, $limit: Int, $page: Int) {
    flaggedStudies(filter: $filter, limit: $limit, page: $page) {
      id
      friendlyId
      externalSource {
        provider
        externalId
      }
      deviceType
      # isExternalDevice
      info {
        patient {
          ...PatientFragment
        }
        interprettingPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        referringPhysician {
          id
          firstName
          lastName
          contact {
            phone1
            nightPhone
            fax
          }
          email
        }
        diagnosis {
          ...DiagnosisFragment
        }
        followOnStudy {
          studyType
          reportDueDate
        }
      }
      start
      stop
      studyType
      status
      referenceCode
      sentReferenceCodeAt
      reportDueDate
      timezone
      studyTimeOffset
      patientFirstSyncDeviceAt
      initialDurationOfStudy
      ecgUploadProgress
      rma
      artifact {
        date
        resolvedAt
        percentage
        lastIssueFound
        commonIssueFound
      }
      lastStudyHistory {
        time
        status
      }
      hasArtifactReport
      linkedStudies {
        id
        patientFirstSyncDeviceAt
      }
      facility {
        id
        name
        timezone
        contact {
          country
        }
        status
        enableLiveECGStream
      }
      device {
        ...DeviceFragment
      }
      initDuration
      lastEvaluationEvent {
        id
        createdAt
        start
        stripImgs
      }
      biofluxDirect {
        status
        id
        senderInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
        recipientInformation {
          latestLabel {
            transaction {
              trackingStatus
            }
          }
        }
      }
      isTest
      ecgDetail
      uploadStatus
      isStopping
      patientPaired
      orderNumber
      isAborting
      isDeviceAssignmentPending
      initiatedTime
      flaggedStudy {
        reason
        resolvedAt
      }
      lastAddressedTime
    }
  }

  ${DEVICE_FRAGMENT}
  ${PATIENT_FRAGMENT}
  ${DIAGNOSIS_FRAGMENT}
`;

export default FLAGGED_STUDIES_QUERY;
